export function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}
//# sourceMappingURL=index.js.map